import { ProofingViewState } from '../store/schema/ProofingViewState';
import { mutatorAction } from 'satcheljs';
import { PremiumPreviewStatus, PremiumPreviewType } from '../store/schema/PremiumPreviewData';

export const onUpdatePremiumSuggestionsData = mutatorAction(
    'onUpdatePremiunSuggestionsDaysLeft',
    (
        viewState: ProofingViewState,
        numberOfDaysLeftToUsePremiunSuggestions: number,
        premiumPreviewStatus: PremiumPreviewStatus,
        premiumPreviewType: PremiumPreviewType,
        premiumSuggestionsCount: number
    ) => {
        viewState.premiumPreviewData.numberOfDaysLeftToUsePremiunSuggestions = numberOfDaysLeftToUsePremiunSuggestions;
        viewState.premiumPreviewData.premiumPreviewStatus = premiumPreviewStatus;
        viewState.premiumPreviewData.premiumPreviewType = premiumPreviewType;
        viewState.premiumPreviewData.premiumSuggestionsCount = premiumSuggestionsCount;
    }
);
